import BookItem from "@app/components/book-item";
import Pagination from "@app/components/pagination";
import ChevronDownArrow from "@app/components/select/chevron-down";
import { CustomSelect } from "@app/components/select/custom-select";
import SkeletonGrid from "@app/components/skeleton-grid";
import {
  DEFAULT_PAGE,
  DEFAULT_REQUEST_PARAMS,
  SortBy,
  SortByOptions,
} from "@app/constants";
import BookService from "@app/services/http/book.service";
import { selectCategories } from "@app/store/category";
import { Book, Meta } from "@app/types";
import { Images } from "@assets/images";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { RequestParams } from "@core/services/http/http.type";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

function BookByCategory() {
  const [searchParams] = useSearchParams();
  const { abortController } = useCancellationRequest();

  const [categoryName, setCategoryName] = useState("");
  const categoryState = useSelector(selectCategories);
  const [books, setBooks] = useState<Book[]>([]);
  const [requestParams, setRequestParams] = useState<RequestParams>({
    ...DEFAULT_REQUEST_PARAMS,
    pageSize: 50,
  });
  const [meta, setMeta] = useState<Meta>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const categoryId = searchParams.get("category_id")
      ? String(searchParams.get("category_id"))
      : "";

    const category = categoryState.list.find(
      (item) => item.id === Number(categoryId)
    );

    if (category) {
      setCategoryName(category.name);
    } else {
      setCategoryName("");
    }
  }, [categoryState, searchParams.get("category_id")]);

  useEffect(() => {
    const categoryId = searchParams.get("category_id")
      ? String(searchParams.get("category_id"))
      : "";

    const newRequestParams: RequestParams = {
      ...requestParams,
    };

    BookService.getBooksByCategory(
      categoryId,
      newRequestParams,
      abortController.signal
    )
      .then((res) => {
        setBooks(res.data.items);
        setMeta(res.data.meta);

        if (
          requestParams.pageNum &&
          res.data.meta.totalPage > 0 &&
          res.data.meta.totalPage < requestParams.pageNum
        ) {
          const newRequestParams: RequestParams = {
            ...requestParams,
            pageNum: DEFAULT_PAGE,
          };

          setRequestParams(newRequestParams);
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams.get("category_id"), requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      pageNum: page,
    };

    setRequestParams(newRequestParams);
  };

  const onSortByChange = (e: number | string) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      sortBy: String(e),
    };

    setRequestParams(newRequestParams);
  };

  return (
    <div className="px-[100px] min-h-[calc(100vh-328px)]">
      <div className="mt-[66px] flex items-center justify-between gap-3">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-[32px]">
          {categoryName}
        </div>
        <CustomSelect
          className="!border-[#616E87] pr-2 w-[200px]"
          options={SortByOptions}
          optionContainerClassName="top-[34px] w-[200px]"
          optionClassName="!min-h-[35px] text-sm text-[#3A4251] font-semibold tracking-[0.028px] whitespace-nowrap px-2 font-[SVN-Gilroy]"
          labelSelectedClassName="text-[#3A4251] text-sm font-semibold tracking-[0.028px] font-[SVN-Gilroy]"
          arrow={<ChevronDownArrow />}
          defaultValue={SortBy.ALL.toString()}
          hasBgColorHover
          onChange={onSortByChange}
        />
      </div>
      {!loading && books.length ? (
        <div>
          <div className="mt-9 flex flex-wrap gap-6">
            {books.map((book) => (
              <div key={book.id}>
                <BookItem book={book} />
              </div>
            ))}
          </div>
          {meta && (
            <div className="flex justify-center mt-3">
              <Pagination
                currentPage={meta.pageNum}
                totalPages={meta.totalPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      ) : !loading ? (
        <div className="mt-[164px] flex flex-col items-center">
          <img
            className="w-[120px]"
            src={Images.ResultNotFound.default}
            alt=""
          />
          <div className="font-[SVN-Gilroy] font-semibold tracking-[0.024px] text-[#171A20]">
            Không tìm thấy kết quả nào cho
          </div>
          <div className="font-[SVN-Gilroy] font-medium tracking-[0.024px] text-[#4E586C]">
            “{categoryName}”
          </div>
        </div>
      ) : (
        <div className="mt-9">
          <SkeletonGrid />
        </div>
      )}
    </div>
  );
}

export default BookByCategory;
